import { vuexHandbook } from '@/store/compositionV2/module/handbook'
import { ChangelogApi } from '@/api/changelog'
import {
  PTOBuildingApi,
  PTOChangeApi,
  PTODocumentApi,
  PtoStatementApi,
  PTOHandbookDocumentFileTypeApi,
  PTOHandbookFotSurchargesApi,
  PTOHandbookсostPersonHourApi,
  PTOHandbookDocumentStatusApi, PTOHandbookEstimateBaseTypesApi,
  PTOHandbookIDApi,
  PTOHandbookJobTypeApi,
  PTOHandbookMeasureUnitApi,
  PTOHandbookNomenclatureStandardApi,
  PTOHandbookNomenclatureTypeApi,
  PTOHandbookObjectStatusApi,
  PTOHandbookProductionTypeApi,
  PTOHandbookProductTypeApi,
  PTOHandbookProjectStatusApi,
  PTOHandbookStatementTypeApi,
  PTOJobApi,
  PTOObjectApi
} from '@/api/pto'

import { mapEstimateBaseTypeItem, mapJobItem } from '@/utils/page/pto/project/pto/map'

const state = () => ({
  buildingList: [],
  objectList: [],

  changelogObjectList: [],

  // Проект: Изменения/Документы/Деф. ведомость
  changeList: [],
  documentList: [],
  statementList: [],

  // проект - ПТО
  projectPTOJobList: [],

  // handbook
  documentFileTypeList: [],
  fotSurchargesList: [],
  сostPersonHourList: [],
  documentStatusList: [],
  estimateBaseTypeList: [],
  handbookIDList: [],
  jobTypeList: [],
  measureUnitList: [],
  nomenclatureStandardList: [],
  nomenclatureTypeList: [],
  productTypeList: [],
  productionTypeList: [],
  statementTypeList: [],
  statusObjectList: [],
  statusProjectList: []
})

const getters = {
  getProjectPTOJobList: state => {
    return state.projectPTOJobList.map(mapJobItem)
  },

  estimateBaseTypeListMapped: state => state.estimateBaseTypeList.map(mapEstimateBaseTypeItem)
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions(),
  async GETBuildingList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOBuildingApi,
      keyStateList: 'buildingList',
      search
    })
  },
  async GETObjectList ({ dispatch }, { buildingId = null, search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOObjectApi,
      keyStateList: 'objectList',
      query: {
        expand: 'estimate_responsible',
        'search[building_id]': buildingId
      },
      search
    })
  },
  async GETChangelogObjectList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: ChangelogApi,
      method: 'getObjects',
      keyStateList: 'changelogObjectList',
      search
    })
  },
  // проект - ПТО
  async GETProjectPTOJobList ({ dispatch }, { projectId, search = null }) {
    await dispatch('GETRequest', {
      api: PTOJobApi,
      keyStateList: 'projectPTOJobList',
      query: {
        expand: 'job_type,executor',
        'search[project_id]': projectId
      },
      search
    })
  },

  // handbook
  async GETDocumentFileTypeList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookDocumentFileTypeApi,
      keyStateList: 'documentFileTypeList',
      search
    })
  },
  async GETFotSurchargesList ({ dispatch }, { buildingId = null, date = null, search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookFotSurchargesApi,
      keyStateList: 'fotSurchargesList',
      search,
      query: {
        'search[Date]': date,
        'search[BuildingId]': buildingId
      }
    })
  },

  async GETCostPersonHourList ({ dispatch }, { search = null, date = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookсostPersonHourApi,
      keyStateList: 'сostPersonHourList',
      search,
      query: date ? {
        'search[Current]': date
      } : {}
    })
  },

  async GETDocumentStatusList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookDocumentStatusApi,
      keyStateList: 'documentStatusList',
      search
    })
  },
  async GETEstimateBaseTypeList ({ dispatch }) {
    await dispatch('GETRequest', {
      api: PTOHandbookEstimateBaseTypesApi,
      keyStateList: 'estimateBaseTypeList'
    })
  },
  async GETHandbookIDList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookIDApi,
      keyStateList: 'handbookIDList',
      search
    })
  },
  async GETJobTypeList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookJobTypeApi,
      keyStateList: 'jobTypeList',
      search
    })
  },
  async GETMeasureUnitList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookMeasureUnitApi,
      keyStateList: 'measureUnitList',
      search
    })
  },
  async GETNomenclatureStandardList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookNomenclatureStandardApi,
      keyStateList: 'nomenclatureStandardList',
      search
    })
  },
  async GETNomenclatureTypeList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookNomenclatureTypeApi,
      keyStateList: 'nomenclatureTypeList',
      search
    })
  },
  async GETProductTypeList ({ dispatch }, { productTypeId = null, search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookProductTypeApi,
      keyStateList: 'productTypeList',
      query: {
        'search[Products]': productTypeId
      },
      search
    })
  },
  async GETProductionTypeList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookProductionTypeApi,
      keyStateList: 'productionTypeList',
      search
    })
  },
  async GETStatusObjectList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookObjectStatusApi,
      keyStateList: 'statusObjectList',
      search
    })
  },
  async GETStatusProjectList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookProjectStatusApi,
      keyStateList: 'statusProjectList',
      search
    })
  },
  async GETStatementTypeList ({ dispatch }, { search = null } = {}) {
    await dispatch('GETRequest', {
      api: PTOHandbookStatementTypeApi,
      keyStateList: 'statementTypeList',
      search
    })
  },

  // Проект: Изменения/Документы/Деф. ведомость
  async GETChangeList ({ dispatch }, { search, projectId }) {
    await dispatch('GETRequest', {
      api: PTOChangeApi,
      keyStateList: 'changeList',
      search,
      query: {
        'search[project_id]': projectId
      }
    })
  },
  async GETDocumentList ({ dispatch }, { search, projectId }) {
    await dispatch('GETRequest', {
      api: PTODocumentApi,
      keyStateList: 'documentList',
      search,
      query: {
        'search[project_id]': projectId,
        'search[status]': 'is_not_canceled'
      }
    })
  },
  async GETStatementList ({ dispatch }, { search, projectId }) {
    await dispatch('GETRequest', {
      api: PtoStatementApi,
      keyStateList: 'statementList',
      search,
      query: {
        'search[project_id]': projectId,
        'search[type]': 'is_not_canceled'
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
